import styled, { css } from 'styled-components';
import { paletteHelper, spacingHelper, mediaHelper, radiusHelper } from '@property.com.au/ui-kit';
import { PageContainer } from '../../../components/PageContainer/PageContainer';
import { Image } from '../../../app-kit/components/Image/Image';
import { SearchByImageFeatureButtonWrapper } from '../../../components/SearchByImageButton/SearchByImageButton';

export const MEDIA_SHOWCASE_BRICK_HEIGHT = 352;
export const MEDIA_SHOWCASE_BRICK_HEIGHT_MOBILE = 368;

export const MediaShowcaseContentContainer = styled.div`
  height: ${MEDIA_SHOWCASE_BRICK_HEIGHT_MOBILE}px;
  border-radius: ${radiusHelper('large')};
  overflow: hidden;

  ${mediaHelper('tabletMin')} {
    height: ${MEDIA_SHOWCASE_BRICK_HEIGHT}px;
  }
`;

export const MediaCountsBadge = styled.div`
  z-index: 1;
  position: absolute;
  top: ${spacingHelper('extraSmall')};
  right: ${spacingHelper('extraSmall')};
  background-color: ${paletteHelper('backgroundOverlayStatic')};
  padding: ${spacingHelper('extraSmall')} ${spacingHelper('small')};
  border-radius: ${radiusHelper('medium')};
`;

export const MediaCountsBadgeV2 = styled.div`
  z-index: 1;
  position: absolute;
  top: ${spacingHelper('extraSmall')};
  left: ${spacingHelper('extraSmall')};
  display: flex;
  gap: ${spacingHelper('extraSmall')};
`;

export const MediaShowcaseBrickContainer = styled(PageContainer)`
  position: relative;
`;

export const OpenModalButton = styled.button`
  position: relative;
  width: 100%;
  height: 100%;
  &:hover {
    cursor: pointer;
  }
  &:disabled {
    cursor: default;
  }
`;

const sharedImgStyles = css`
  height: 100%;
  width: 100%;
  object-fit: cover;
  vertical-align: middle;
`;

export const StyleAerialImageComponent = styled.img`
  ${sharedImgStyles}
`;

export const StyledListingImageComponent = styled(Image)`
  height: inherit;
  width: inherit;

  ${({ dangerouslySetClassnames }) =>
    dangerouslySetClassnames?.img &&
    css`
      .${dangerouslySetClassnames.img} {
        ${sharedImgStyles}
      }
    `}
`;

export const MetromapLogo = styled.img`
  max-height: 2rem;
  position: absolute;
  right: ${spacingHelper('extraSmall')};
  bottom: ${spacingHelper('extraSmall')};
`;

export const SearchByImageWrapper = styled(SearchByImageFeatureButtonWrapper)<{
  $isSplitItem: boolean;
}>`
  top: ${spacingHelper('extraSmall')};
  z-index: 1;
  position: absolute;
  right: ${spacingHelper('small')};

  ${mediaHelper('tabletMin')} {
    ${({ $isSplitItem }) =>
      $isSplitItem &&
      css`
        left: 70%;
        right: unset;
        transform: translateX(calc(-100% - ${spacingHelper('small')}));
      `}
  }
`;
